<div class="[ relative container container-max-width-3xl stack ]">
  <ng-container *ngIf="role$ | async as role">
    <ng-container [ngSwitch]="role">
      <!-- Student registration -->
      <ng-container *ngSwitchCase="'student'">
        <h1 class="[ headline-large text-center ]" data-cy="form-header">Registreer als leerling</h1>

        <campus-maintenance-mode
          *ngIf="isMaintenanceMode$ | async; else studentOperationalMode"
          [statusPageUrl]="statusPageUrl"
        ></campus-maintenance-mode>
        <ng-template #studentOperationalMode>
          <dcr-animated-kai
            #kai
            src="assets/rive/kai_state_machine.riv"
            autoplay
            track-lookat
            react-to-click
            class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
          ></dcr-animated-kai>

          <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
            <div class="[ p-b-m ]">
              <polpo-register-form (register)="register($event)" [error]="registrationError$ | async"></polpo-register-form>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <!-- Teacher registration -->
      <ng-container *ngSwitchCase="'teacher'">
        <h1 class="[ headline-large text-center ]" data-cy="form-header">Registreer als leerkracht</h1>

        <campus-maintenance-mode
          *ngIf="isMaintenanceMode$ | async; else teacherOperationalMode"
          [statusPageUrl]="statusPageUrl"
        ></campus-maintenance-mode>
        <ng-template #teacherOperationalMode>
          <dcr-animated-kai
            #kai
            src="assets/rive/kai_state_machine.riv"
            autoplay
            track-lookat
            react-to-click
            class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
          ></dcr-animated-kai>

          <ng-container *ngIf="campaign$ | async as campaign">
            <h2 *ngIf="campaign.key" class="[ title-large text-center text-secondary ]">
              {{ campaign.title }}
            </h2>

            <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
              <div class="[ p-b-m ]">
                <div *ngIf="campaign.isExpired" class="[ corner-m p-i-m p-b-s error-container border border-error body-large ]">
                  Deze campagne is afgelopen.
                </div>
                <polpo-register-teacher-form
                  *ngIf="campaign.key && !campaign.isExpired"
                  (register)="registerTeacher($event, campaign.key)"
                  [error]="registrationError$ | async"
                ></polpo-register-teacher-form>
              </div>
            </div>

            <div *ngIf="!campaign.key" class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
              <div class="[ p-b-m ]">
                <p class="[ body-large text-center text-secondary ]">Contacteer uw schoolbeheerder voor uw logingegevens van Polpo.</p>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<dcr-dialog
  *ngIf="welcomeDialog$ | async as welcomeDialog"
  open
  [attr.headline]="welcomeDialog.headline"
  [attr.confirm-label]="welcomeDialog.confirmLabel"
  [attr.type]="welcomeDialog.confirmType"
  (confirm)="onWelcomeConfirm()"
  (cancel)="onWelcomeCancel()"
>
  <ng-container *ngIf="welcomeDialog.existingEmail; else newUserMessage">
    Je hebt reeds een account bij ons.
    <br />
    <ng-container *ngIf="welcomeDialog.campaign">
      We hebben je toegevoegd aan de Keurieus school. Je krijgt op het platform alle Keurieus-producten te zien.
      <br />
    </ng-container>
    <br />
    Meld je aan met dit e-mailadres:
    <strong>{{ welcomeDialog.existingEmail }}</strong>
  </ng-container>
  <ng-template #newUserMessage>
    De registratie is voltooid.
    <br />
    We brengen je zo dadelijk naar het platform.
  </ng-template>
</dcr-dialog>
